/** Human-readable message from Error, PostgREST, or unknown thrown values. */
export function toErrorMessage(error: unknown, fallback = 'Something went wrong'): string {
  if (error == null) return fallback
  if (typeof error === 'string' && error.trim()) return error
  if (error instanceof Error && error.message.trim()) return error.message

  if (typeof error === 'object') {
    const e = error as { message?: unknown; error_description?: unknown; code?: unknown; details?: unknown; hint?: unknown }
    const message = typeof e.message === 'string' ? e.message.trim() : ''
    if (message) {
      const code = typeof e.code === 'string' && e.code ? ` (${e.code})` : ''
      const details = typeof e.details === 'string' && e.details ? `: ${e.details}` : ''
      return `${message}${code}${details}`
    }
    if (typeof e.error_description === 'string' && e.error_description.trim()) {
      return e.error_description
    }
  }

  return fallback
}

export function isAuthSessionError(error: unknown): boolean {
  const message = toErrorMessage(error, '').toLowerCase()
  const code =
    typeof error === 'object' && error && 'code' in error
      ? String((error as { code?: unknown }).code ?? '')
      : ''
  return (
    code === 'PGRST303' ||
    message.includes('jwt expired') ||
    message.includes('invalid jwt') ||
    message.includes('not authenticated') ||
    (message.includes('jwt') && message.includes('expired'))
  )
}
